import { CrewMerchantUi } from 'corso-types';
import { ReactNode } from 'react';
import { formatter } from 'corso-web-lib';

type CustomField = CrewMerchantUi.AppliedCustomField;

// Retrieve the underlying enum or type for the valueType
type CustomFieldValueType = CustomField['valueType'];

export const customFieldValueTypeFormatter = {
  Text: (value: string) => value,
  Number: (value: string) => value,
  Date: (value: string) => (
    <time dateTime={value}>{formatter.date(value)}</time>
  ),
  Select: (value: string) => value,
  MultiSelect: (value: string) => value,
} as const satisfies Record<CustomFieldValueType, (value: string) => ReactNode>;
